"use client";

import type { ChartData, FinancialSnapshotNarrative } from "@/lib/types/financial-snapshot";
import { ChartCard } from "../ChartCard";
import { ChartPlaceholder } from "../ChartPlaceholder";
import { PeBandChart } from "../charts/PeBandChart";

interface Props {
  data: ChartData;
  narrative: FinancialSnapshotNarrative | null;
}

function fmtNum(v: number | null, digits = 2): string {
  return v == null ? "-" : v.toFixed(digits);
}
function fmtPct(v: number | null): string {
  return v == null ? "-" : `${(v * 100).toFixed(1)}%`;
}

export function ValuationTab({ data, narrative }: Props) {
  const val = data.currentMetrics.valuation;
  const pills: Array<{ label: string; value: string }> = [
    { label: "PE", value: fmtNum(val.pe) },
    { label: "PEG", value: fmtNum(val.peg) },
    { label: "EV/EBITDA", value: fmtNum(val.evEbitda) },
    { label: "FCF Yield", value: fmtPct(val.fcfYield) },
  ];

  return (
    <div className="space-y-5">
      <ChartCard title="PE Band (25 / 50 / 75 percentile)" caption={narrative?.insights.peBand}>
        {data.peBand ? (
          <PeBandChart rows={data.peBand} />
        ) : (
          <ChartPlaceholder message="Not enough profitable quarters (need 8+) to compute PE Band." />
        )}
      </ChartCard>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {pills.map((p) => (
          <div
            key={p.label}
            className="bg-surface-light/5 border border-surface-light/10 rounded-lg px-3 py-2"
          >
            <div className="text-[10px] uppercase tracking-wide text-muted-foreground">
              {p.label}
            </div>
            <div className="text-sm font-semibold font-tabular mt-0.5">{p.value}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
